/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusFaqDetailDto } from '../../models/lexplus-faq-detail-dto';

export interface FaqControllerRemovePdfV1$Params {
  id: number;
  sprache: string;
}

export function faqControllerRemovePdfV1(http: HttpClient, rootUrl: string, params: FaqControllerRemovePdfV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusFaqDetailDto>> {
  const rb = new RequestBuilder(rootUrl, faqControllerRemovePdfV1.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('sprache', params.sprache, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusFaqDetailDto>;
    })
  );
}

faqControllerRemovePdfV1.PATH = '/v1/faq/{id}/pdf/{sprache}';
